import React from 'react';

let prevArrow = (onPrevSlideClick,showPrevButton)=>{ 
  if(showPrevButton)
  return (<span className="headerArrow pull-left silderControlElement" onClick={onPrevSlideClick}>&lt;</span>);
  else return (<span></span>);
}

  let nextArrow =  (onNextSlideClick,showNextButton)=>{
    if(showNextButton)
    return ( <span className="headerArrow pull-right silderControlElement" onClick={onNextSlideClick}>&gt;</span>);
    else return (<span></span>);
  }

const SliderHeaderComponent = ({header,index,onPrevSlideClick,onNextSlideClick,showNextButton,showPrevButton}) => (
  <div className="headerBar clearfix">
  {prevArrow(onPrevSlideClick,showPrevButton)}
  <span className="silderControlElement sliderIndex">{index}. </span><span className="silderControlElement">{header}</span>
  {nextArrow(onNextSlideClick,showNextButton)}
  </div>
)
export default SliderHeaderComponent
